import { z } from "zod";

import { filter } from "~/tools/filter";
import { isPresent } from "~/tools/is-present";
import { Template } from "~/tools/template";

const FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_PROMQL = Template<null>("");
const FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC = {
	query: FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_PROMQL,
};

const timeSeriesQuerySchema = z
	.object({
		kind: z.literal("TimeSeriesQuery"),
		spec: z.object({
			plugin: z
				.object({
					kind: z.literal("PrometheusTimeSeriesQuery"),
					spec: z
						.object({
							query: z
								.string()
								.transform((query) => Template<null>(query))
								.catch(FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_PROMQL),

							alias: z
								.string()
								.transform((query) => Template<null>(query))
								.optional()
								.catch(undefined),

							minStep: z
								.string()
								.transform((query) => Template<null>(query))
								.optional()
								.catch(undefined),
						})
						.catch(FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC),
				})
				.catch({
					kind: "PrometheusTimeSeriesQuery" as const,
					spec: FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC,
				}),
		}),
	})
	.transform(({ spec }) => spec.plugin.spec)
	.catch(FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC);

export type TimeSeriesQuery = z.infer<typeof timeSeriesQuerySchema>;

export const timeSeriesQueries = z
	.array(timeSeriesQuerySchema.optional().catch(undefined))
	.catch([])
	.transform(filter(isPresent));
